import {authLoader} from '@app/navigations/loader';
import {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_MIQNAFSURVEY} from '@app/navigations/RoutePathConstant';

const MiqnafSurvey = lazy(() =>
  import('../../../screens/MiqnafSurvey')
    .then(module => ({default: module.MiqnafSurvey})));

const  MiqnafSurveyNavigation = [
  {
    path:ROUTE_MIQNAFSURVEY,
    loader:authLoader,
    element:(
      <Suspense fallback={<Spin />}>
        <MiqnafSurvey />
      </Suspense>
    ),
  },
];

export default MiqnafSurveyNavigation;
